// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_ef5bb01","icon":"_348e018","loader":"_ae9de34","tooltip":"_ec64406","tooltipWrapper":"_68b97cc","tooltipClubDescription":"_35ab088"};